import { Switch } from "app/components/Switch";
import clsx from "clsx";
import React from "react";
import { IDefaultCustomization } from "../../types";
import { DefaultCustomizationList } from "./data";

interface Props {
  onCheckedChange(name: string, checked: boolean): void;
  defaultCustomization: IDefaultCustomization;
}
const Index: React.FC<Props> = ({ onCheckedChange, defaultCustomization }) => {
  return (
    <div className="flex flex-col gap-[20px] w-full">
      <h6 className="text-lg leading-[27px] font-medium text-black text-center">
        Customize defaults for Starter
      </h6>

      <div className="flex flex-col gap-[16px]">
        {DefaultCustomizationList.map((item) => {
          const isChecked = Boolean(defaultCustomization[item.id]);
          return (
            <button
              key={item.id}
              className={clsx(
                "flex flex-row justify-between items-center border rounded-[4px] px-[16px] py-[14px] transition",
                isChecked ? "border-primary" : "border-gray-100 ",
                item.isDisabled
                  ? "opacity-50 "
                  : "hover:bg-gray-400 "
              )}
              disabled={item.isDisabled}
            >
              <div className="flex flex-row gap-[10px] items-center text-start ">
                <div
                  style={{ backgroundColor: item.color }}
                  className="size-[26px] min-w-[26px] rounded-[4px] flex items-center justify-center"
                >
                  {item.icon}
                </div>
                <div className="flex flex-col">
                  <h6 className="text-sm font-medium text-black">
                    {item.title}
                  </h6>
                  <p className="text-xs text-secondary">{item.caption}</p>
                </div>
              </div>

              <Switch
                disabled={item.isDisabled}
                checked={isChecked}
                onCheckedChange={(value) => {
                  if (item.isDisabled) return;
                  onCheckedChange(item.id, value);
                }}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Index;
